import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'HOME', path: '/' },
    { name: 'ABOUT', path: '/about' },
    { name: 'THE METHOD', path: '/the-method' },
    { name: 'OFFERINGS', path: '/#offerings' },
    { name: 'CONTACT', path: '/#contact' },
  ];

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          isScrolled ? 'bg-sacred-moss shadow-lg' : 'bg-transparent'
        }`}
      >
        <div className="w-full px-8 lg:px-16 py-6">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link to="/" className="flex-shrink-0 cursor-pointer">
              <img 
                src="https://public.readdy.ai/ai/img_res/ba7ef960-0c6d-41b7-b8de-4ad297b17548.png" 
                alt="House of Selkara Logo" 
                className="h-16 w-auto"
              />
            </Link>

            {/* Navigation Links */}
            <div className="flex items-center gap-12">
              {navLinks.map((link, index) => (
                <div key={link.path} className="flex items-center gap-12">
                  <Link
                    to={link.path}
                    className={`font-cormorant text-ancient-gold tracking-widest-plus text-sm hover:text-blush-ash transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                      location.pathname === link.path ? 'text-blush-ash' : ''
                    }`}
                  >
                    {link.name}
                  </Link>
                  {index < navLinks.length - 1 && (
                    <span className="text-ancient-gold text-sm">·</span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom border line */}
        <div className="w-full h-px bg-ancient-gold opacity-30"></div>
      </nav>

      {/* Spacer to prevent content from going under fixed nav */}
      <div className="h-24"></div>
    </>
  );
}